import React from "react";
import styles from "./FailedPaymentCard.module.scss";
import { ReactComponent as FailedPaymentIcon } from "../../assets/images/payment-failed.svg";

type FailedPaymentCardProps = {
  paymentmethod: string;
  message: string;
};
const FailedPaymentCard = ({
  paymentmethod,
  message,
}: FailedPaymentCardProps) => {
  return (
    <div className={styles.successful_payment}>
      <FailedPaymentIcon />
      <h3>Payment Failed</h3>
      <p>{message ?? "Payment not received"}</p>
    </div>
  );
};

export default FailedPaymentCard;
